import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text, Spacer, Button } from '../components';
import useThemeContext from '../styles/useThemeContext';

export default function NonCollapsibleCardContainer(props) {
  const {
    title,
    children,
    titleLeft,
    titleStyle,
    boldTitle,
    bottomButton,
    style,
    noTitle,
    noPadding,
    onLayout,
    onBottomButtonPress,
  } = props;
  const theme = useThemeContext();

  return (
    <View
      style={[
        cardItemStyles.container,
        {
          backgroundColor: theme.colors.cardContainer,
        },
        style,
      ]}
    >
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        {!noTitle &&
          (title ? (
            <Text bold={boldTitle} style={[cardItemStyles.text, titleStyle]}>
              {title}
            </Text>
          ) : (
            <View style={cardItemStyles.spacer} />
          ))}
        {titleLeft ? <Spacer /> : null}
      </View>
      <View style={!noPadding && cardItemStyles.content} onLayout={onLayout}>
        {children}
      </View>
      {bottomButton && (
        <Button
          outlined
          noBorder
          style={cardItemStyles.bottomButton}
          text={bottomButton}
          onPress={onBottomButtonPress}
          ignoreSentenceCase
        />
      )}
    </View>
  );
}

const cardItemStyles = StyleSheet.create({
  container: {
    marginVertical: 5,
  },
  content: {
    paddingHorizontal: 20,
    paddingVertical: 18,
    alignSelf: 'stretch',
  },
  spacer: {
    height: 20,
  },
  text: {
    alignSelf: 'stretch',
    textAlign: 'center',
    marginTop: 32,
    marginBottom: 8,
  },
  bottomButton: {
    alignSelf: 'flex-start',
    borderRadius: 0,
    marginBottom: 12,
    marginLeft: -16,
    justifyContent: 'center',
  },
  title: {
    fontSize: 14,
    fontWeight: 700,
  },
});
